import { JpkVatCodes } from "@skylab-shared/dataModel";

export const JpkVatProcedures = [
	JpkVatCodes.IED,
	JpkVatCodes.WSTO_EE,
	JpkVatCodes.SW,
	JpkVatCodes.EE,
	JpkVatCodes.TT_D,
	JpkVatCodes.I_42,
	JpkVatCodes.I_63,
	JpkVatCodes.B_SPV,
	JpkVatCodes.B_SPV_DOSTAWA,
	JpkVatCodes.B_MPV_PROWIZJA,
];
